"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fdate_1 = require("./fdate");
function dateFromPesel(pesel) {
    if (typeof pesel != 'string' || pesel.length < 6) {
        return '';
    }
    var year = parseInt(pesel.substring(0, 2), 10);
    var month = parseInt(pesel.substring(2, 4), 10) - 1;
    var day = parseInt(pesel.substring(4, 6), 10);
    if (month >= 80) {
        year += 1800;
        month = month - 80;
    }
    else if (month >= 60) {
        year += 2200;
        month = month - 60;
    }
    else if (month >= 40) {
        year += 2100;
        month = month - 40;
    }
    else if (month >= 20) {
        year += 2000;
        month = month - 20;
    }
    else {
        year += 1900;
    }
    var date = new Date(year, month, day);
    return fdate_1.default(date);
}
exports.default = dateFromPesel;
//# sourceMappingURL=dateFromPesel.js.map